module.exports = __webpack_public_path__ + "static/media/montblanc-what-moves-you-makes-you-print.56758ec7.jpg";